import React from "react";
import {Link} from "react-router-dom";

function DashboardPage() {
    return (
        <div>Administrace webu <Link to="/">rainbowpictures.cz</Link></div>
    );
}

export default DashboardPage;